/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import { useState } from "react";
import { useQuery } from "react-query";
import { paymentStatus } from "src/services/Payment";
import CustomLoader from "src/shared/CustomLoader";
import Header from "src/shared/Header";
import useReactRouterDomQuery from "src/utils/hooks/useQuery";

function PaymentResponse() {
  const query = useReactRouterDomQuery();
  const orderId = query.get("orderId") as string;
  const [statusRes, setStatusRes] = useState<any>({});

  const { isFetching, isError } = useQuery(["paymentStatus"], () => paymentStatus(orderId), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled: !!orderId,
    onSuccess: (response: any) => {
      console.log("response ", response);
      setStatusRes(response);
    },
    onError: (error: any) => {
      console.log("error ", error);
    }
  });

  console.log("status res ", statusRes);

  if (isFetching) {
    return <CustomLoader />;
  }

  if (isError) {
    return <div className="text-center mt-20 text-2xl font-bold text-hotShot">No Data Found</div>;
  }

  return (
    <div>
      <Header isEnable={false} />
      <p className="text-center mt-20 text-2xl font-bold text-hotShot">
        {statusRes?.error
          ? "Payment could not be processed"
          : statusRes?.data?.status === "Success"
          ? "Payment has been received"
          : "Payment could not be processed"}
      </p>
    </div>
  );
}

export default PaymentResponse;
